export const font = {
    baseColor: '#4E64A0' ,
    baseFontColor: '#191919',
    baseCheckboxColor: '#464646'
}